/* Template: Homepage Hero button section scrolling
 ========================================================================== */

template.hero_btn_scroll = () => {
    'use strict';

    const btn = $('.btn--hero_scroll'),
        section = $('section.homepage-cta');

    btn.on('click', () => {
        $('html, body').animate({
            scrollTop: section.offset().top
        }, 1000);
    });

};
